import React, { useState, useRef, useEffect } from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import ModalPreview from '../ui/ModalPreview';
import { sharingSocials } from '../features/greenpill/sharingSocials';
import { CopyIconSmall } from '../assets/icons/UserProfileIcons';
import { toast } from 'sonner';
import ButtonNew from '../ui/ButtonNew';

const ShareButton = ({
  projectTitle,
  certificateImage,
  shareUrl,
  shareText,
  className = ''
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showShareDropdown, setShowShareDropdown] = useState(false);
  const shareDropdownRef = useRef();
  const [searchParams] = useSearchParams();
  const { certificateId } = useParams();

  useEffect(() => {
    function handleClick(e) {
      if (shareDropdownRef.current && !shareDropdownRef.current.contains(e.target)) {
        setShowShareDropdown(false);
      }
    }
    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);

  const handleShare = (platform) => {
    // Build the share URL using the main domain (Firebase hosting rewrites handle routing to socialShare function)
    const baseUrl = 'https://app.impactfoundry.xyz';
    const shareUrl = new URL(`${baseUrl}/profile/gallery/projectic/${certificateId}`);

    // For Twitter, use clean URL without timestamp so Twitter can properly cache the card
    // The Firebase function will handle redirecting users to /share/ version

    const shareText = `My proof of impact just went onchain, thanks to Impact Certificates, minted with Impact Foundry!

Check out my Project IC here → ${shareUrl.toString()}`;

    const encodedUrl = encodeURIComponent(shareUrl.toString());
    const encodedText = encodeURIComponent(shareText);
    let shareLink = '';

    switch (platform.toLowerCase()) {
      case 'whatsapp':
        shareLink = `https://wa.me/?text=${encodedText}`;
        break;
      case 'telegram':
        shareLink = `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`;
        break;
      case 'facebook':
        shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`;
        break;
      case 'twitter':
        shareLink = `https://twitter.com/intent/tweet?text=${encodedText}`;
        break;
      case 'reddit':
        shareLink = `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedText}`;
        break;
      case 'messages':
        shareLink = `sms:&body=${encodedText}`;
        break;
      case 'discord':
        navigator.clipboard.writeText(shareUrl.toString());
        alert('Link copied to clipboard! Please paste it manually in Discord.');
        return;
      case 'snapchat':
      case 'instagram':
        alert(`${platform} does not support direct web sharing. Please share manually.`);
        return;
      default:
        return;
    }

    if (shareLink) {
      window.open(shareLink, '_blank', 'width=550,height=420');
    }
  };

  const handleCopyLink = () => {
    // Build the same URL structure for copy link using main domain
    const baseUrl = 'https://app.impactfoundry.xyz';
    const shareUrl = new URL(`${baseUrl}/profile/gallery/projectic/${certificateId}`);

    // Use clean URL - Firebase function will handle proper routing

    navigator.clipboard.writeText(shareUrl.toString());
    toast.success("Link copied to clipboard!'")
  };



  return (
    <>

      <ButtonNew
        type="button"
        className=''
        onClick={() => setShowModal(true)}

        variant="neutral"
        size="md"
      >
        <span className='flex items-center gap-2'>


          <svg
            className="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92S19.61 16.08 18 16.08z" />
          </svg>
          <span>
            Share
          </span>
        </span>

      </ButtonNew>
      <ModalPreview
        isOpen={showModal}
        footer={
          <div className="flex items-center gap-2">
            <ButtonNew
              type="button"
              className=''
              onClick={handleCopyLink}

              variant="neutral"
              size="md"
            >
              <div className='flex items-center gap-2'>


                <div>
                  <span>Copy Link</span>
                </div>
                <div className=''>
                  <CopyIconSmall />
                </div>
              </div>

            </ButtonNew>


            <div className="relative" ref={shareDropdownRef}>
              <ButtonNew
                type="button"
                className=''
                onClick={() => setShowShareDropdown((prev) => !prev)}

                variant="neutral"
                size="md"
              >
                <div className='flex items-center gap-2'>
                  <div>
                    <span>Share</span>
                  </div>
                  <div className=''>
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92S19.61 16.08 18 16.08z" />
                    </svg>
                  </div>


                </div>

              </ButtonNew>


              <div
                className={`z-[2000] w-[25.875rem] ${showShareDropdown ? 'absolute' : 'hidden'
                  } bg-neutral50F rounded-lg rounded-tl-none shadow px-4 py-3 max-h-[5rem] overflow-y-auto top-full left-0`}
                style={{
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#6B7280 #374151'
                }}
              >
                <div className="grid grid-cols-6 gap-2">
                  {sharingSocials?.map((social) => {
                    return (
                      <div
                        onClick={() => handleShare(social.label)}
                        className="flex flex-col items-center cursor-pointer hover:opacity-80 transition-opacity"
                        key={social?.label}
                      >
                        <img className="w-11 h-11" src={social?.image} alt={social?.label} />
                        <span className="text-textPrimary text-[.65rem]">{social?.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        }
        onClose={() => setShowModal(false)}
        imageUrl={certificateImage}
        title="Share Impact Certificate"
        width="w-[43rem] lg:w-[46rem] xl:w-[50rem] "
      />
    </>
  );
};

export default ShareButton;
